var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booking"},[_c('location',{on:{"show-mobile-calendar":_vm.showMobileCalendar}}),_vm._v(" "),_c('calendar-layout',{class:{ show: _vm.isShowMobileCalendar },on:{"closeDataModal":function($event){_vm.isShowMobileCalendar = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a3f4eda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/BookingLayout.vue
// module id = null
// module chunks = 